export interface ComplianceError {
    errorCode?: number;
    errorDescription?: string;
}

export interface ComplianceFinding {
    name: string;
    value: string;
    level?: string;
}

export interface ComplianceMeta {
    inProgress?: boolean;
    phoneNumber?: string;
    transactionsAmount?: number;
    vendor: string;
    'X-CoxAuto-Correlation-Id': string;
}

export interface ComplianceData {
    errors?: ComplianceError[] | null;
    findings?: ComplianceFinding[];
    meta?: ComplianceMeta;
    status?: string;
}

export enum ComplianceType {
    OFAC = 'OFAC',
    RED_FLAG = 'RED_FLAG',
    CONSISTENCY_CHECK = 'CONSISTENCY_CHECK',
    ID_VERIFICATION = 'ID_VERIFICATION',
    SYNTHETIC_ID_VERIFICATION = 'SYNTHETIC_ID_VERIFICATION'
}

export enum ComplianceStatus {
    NOT_STARTED = 'NOT_STARTED',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
    STARTED = 'STARTED',
    PASS = 'PASS',
    FAIL = 'FAIL',
    ERROR = 'ERROR',
    COMPLETED = 'COMPLETED',
    UNDETERMINED = 'UNDETERMINED'
}

export enum DocumentVerificationTrustReasons {
    docFrontBackMatch = 'docFrontBackMatch',
    docFrontBackNoMatch = 'docFrontBackNoMatch',
    docIrregularOrTampered = 'docIrregularOrTampered',
    faceMatch = 'faceMatch',
    faceNoMatch = 'faceNoMatch',
    faceImageIrregularOrTampered = 'faceImageIrregularOrTampered',
    faceMatchLowConfidence = 'faceMatchLowConfidence',
    faceMatchMediumConfidence = 'faceMatchMediumConfidence',
    faceMatchHighConfidence = 'faceMatchHighConfidence',
    docExpired = 'docExpired',
    docTypeNotSupported = 'docTypeNotSupported',
    docPhotoNotVisible = 'docPhotoNotVisible',
    livenessLive = 'livenessLive',
    livenessNotLive = 'livenessNotLive'
}

export enum BinaryValues {
    Y = 'Y',
    N = 'N',
    U = 'U'
}

export enum SyntheticFindingKey {
    SharedSsn = 'sharedSsn',
    VerifiedSsn = 'verifiedSsn',
    InvalidSsn = 'invalidSsn',
    SharedAddress = 'sharedAddress',
    IdentityConfirmation1 = 'identityConfirmation1',
    IdentityConfirmation2 = 'identityConfirmation2',
    Inquiry = 'inquiry',
    DeathMasterHit = 'deathMasterHit'
}

export const enum AssessmentLevel {
    Level0 = 0,
    Level1 = 1,
    Level2 = 2,
    Level3 = 3,
    Level4 = 4,
    Level5 = 5
}

export const AllowedAssessmentLevels = [
    AssessmentLevel.Level0,
    AssessmentLevel.Level1,
    AssessmentLevel.Level2,
    AssessmentLevel.Level3,
    AssessmentLevel.Level4,
    AssessmentLevel.Level5
] as const;

export interface ComplianceSections {
    idVerification?: ComplianceData | null;
    OFAC?: ComplianceData | null;
    redFlags?: ComplianceData | null;
    syntheticIDVerification?: ComplianceData | null;
    dealertrackDetailsHref?: string;
}

export interface IParticipantsSPD {
    commonConsumerId: string;
    compliance: ComplianceSections;
}
export enum StatusValue {
    Passed = 'Passed',
    Failed = 'Failed',
    Undetermined = 'Undetermined',
    Error = 'Error',
    NotCompleted = 'Not completed yet',
    Initiated = 'Pending'
}

export const completedStatusMap = {
    [BinaryValues.N]: ComplianceStatus.FAIL,
    [BinaryValues.Y]: ComplianceStatus.PASS,
    [BinaryValues.U]: ComplianceStatus.UNDETERMINED
};

export enum ResendIdRequestStatus {
    NotRequested = 'Not Requested',
    Started = 'Started',
    Completed = 'Completed'
}
